export default {"src":"/_next/static/media/san.5052cd0f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};